import { render, staticRenderFns } from "./update-log.vue?vue&type=template&id=33550fc8&scoped=true&"
import script from "./update-log.vue?vue&type=script&lang=js&"
export * from "./update-log.vue?vue&type=script&lang=js&"
import style0 from "./update-log.vue?vue&type=style&index=0&id=33550fc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33550fc8",
  null
  
)

export default component.exports